<nav class="navbar header-navbar pcoded-header" header-theme="theme4">
    <div class="navbar-wrapper">
        <div class="navbar-logo">
            <a class="mobile-menu" id="mobile-collapse" href="#!">
                <i class="ti-menu"></i>
            </a>
            <a class="mobile-search morphsearch-search" href="#">
                <i class="ti-search"></i>
            </a>
            <a [routerLink]="['/v2']">
                <img class="img-fluid" src="assets/images/logo.png" alt="Theme-Logo" />
            </a>
            <a class="mobile-options">
                <i class="ti-more"></i>
            </a>
        </div>
        <div class="navbar-container container-fluid">
            <div>
                <ul class="nav-left">
                    <li>
                        <div class="sidebar_toggle">
                            <a href="javascript:void(0)"><i class="ti-menu"></i></a>
                        </div>
                    </li>
                </ul>

                <span style="display:inline-flex; align-items:center; height:60px; color:orange; font-size:26px; font-weight:bold;">
                    Ambiente {{env}}
                </span>

                <ul class="nav-right">
                    <li class="header-notification lng-dropdown" *ngIf="traduccion" hidden>
                        <a href="javascript:void(0)" id="dropdown-active-item">
                            <i class="flag-icon flag-icon-mx m-r-5" *ngIf="lang == 'es'"></i>
                            <i class="flag-icon flag-icon-us m-r-5" *ngIf="lang == 'en' "></i>
                            <i class="flag-icon flag-icon-fr m-r-5" *ngIf="lang == 'fr' "></i>
                            <i class="flag-icon flag-icon-pt m-r-5" *ngIf="lang == 'pt' "></i>
                        </a>
                        <ul class="show-notification">
                            <li>
                                <a href="javascript:void(0)" (click)="toogleLanguage('en')">
                                    <i class="flag-icon flag-icon-us m-r-5"></i> {{"seccion.comun.englishLabel" |
                                    translate }}
                                </a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" (click)="toogleLanguage('es')">
                                    <i class="flag-icon flag-icon-mx m-r-5"></i> {{"seccion.comun.spanishLabel" |
                                    translate }}
                                </a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" (click)="toogleLanguage('pt')">
                                    <i class="flag-icon flag-icon-pt m-r-5"></i> {{"seccion.comun.portuguesLabel" |
                                    translate }}
                                </a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" (click)="toogleLanguage('fr')">
                                    <i class="flag-icon flag-icon-fr m-r-5"></i> {{"seccion.comun.frenchLabel" |
                                    translate }}
                                </a>
                            </li>
                        </ul>
                    </li>

                    <!-- #region Notificaciones -->
                    <li class="header-notification" (click)="viewNotifyWindow()">
                        <a id="button-notify">
                            <i class="ti-bell cursor"></i>
                            <span class="badge cursor">{{numNotify}}</span>
                        </a>
                        <div class="show-notification content" id="notify-panel" style="visibility: hidden !important">
                            <div class="notify-header">
                                <h6>Notificaciones</h6>
                            </div>
                            <p *ngIf="numNotify == 0 && !isLoadingNotify" class="menssages-response">No hay
                                notificaciones para mostrar.</p>
                            <p *ngIf="isLoadingNotify" class="menssages-response">Buscando notificaciones...</p>
                            <ul class="content-notify" *ngIf="!isLoadingNotify && numNotify > 0">
                                <li class="notify" *ngFor="let notify of notifications">
                                    <div class="media" (click)="seleccionarNotificacion(notify.notificacionId)">
                                        <div class="media-body">
                                            <p class="notification-msg">
                                                <b>{{notify.module}}:</b> {{notify.shortContent}}
                                            </p>
                                            <span class="notification-time">{{notify.timeAgo}}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="notify-footer cursor">
                            </div>
                        </div>
                    </li>
                    <!-- #endregion Notificaciones -->

                    <li class="user-profile header-notification">
                        <img [src]="perfil.imagenPerfilBase64" alt="Foto de perfil" class="perfil-img" 
                            (error)="perfil.imagenPerfilUrl='assets/images/user.png'">

                        <span style="cursor: default !important; color: white !important;">{{ user.nombre }} {{
                            user.sNombre }}</span>
                        <i class="ti-angle-down"></i>

                        <ul class="show-notification profile-notification">
                            <li (click)="miPerfil('Mi Perfil')">
                                <a href="#" *ngIf="traduccion">
                                    <i class="ti-user"></i> {{ "botones.miperfil" | translate }}
                                </a>
                                <a href="#" *ngIf="!traduccion">
                                    <i class="ti-user"></i> Mi Perfil
                                </a>
                            </li>
                            <li (click)="miPerfil('Soporte')" >
                                <a href="#" *ngIf="traduccion">
                                    <i class="ti-headphone-alt"></i> {{ "botones.soporte" | translate }}
                                </a>
                                <a href="#" *ngIf="!traduccion">
                                    <i class="ti-headphone-alt"></i> Soporte
                                </a>
                            </li>
                            <li (click)="miPerfil('Acerca de')">
                                <a href="#" *ngIf="traduccion">
                                    <i class="ti-info-alt"></i> {{ "botones.acercade" | translate }}
                                </a>
                                <a href="#" *ngIf="!traduccion">
                                    <i class="ti-info-alt"></i> Acerca de
                                </a>
                            </li>
                            <li (click)="miPerfil('Preguntas frecuentes')" >
                                <a href="#" *ngIf="traduccion">
                                    <i class="ti-help"></i> {{ "botones.faq" | translate }}
                                </a>
                                <a href="#" *ngIf="!traduccion">
                                    <i class="ti-help"></i> Preguntas frecuentes
                                </a>
                            </li>
                            <li (click)="cerrarSesion()">
                                <a href="#" *ngIf="traduccion"> 
                                    <i class="ti-shift-right"></i> {{ "botones.cerrarsesion" | translate }}
                                </a>
                                <a href="#" *ngIf="!traduccion"> 
                                    <i class="ti-shift-right"></i> Salir 
                                </a>
                            </li>
                        </ul>
                    </li>
                    <app-mi-perfil-popup 
                        *ngIf="isMiPerfilOpen" 
                        [selectedOption]="selectedMiPerfilOption"
                        (close)="isMiPerfilOpen = false">
                    </app-mi-perfil-popup>
                </ul>
                <!-- search -->
                <div id="morphsearch" class="morphsearch">
                    <form class="morphsearch-form">
                        <input class="morphsearch-input" type="search" placeholder="Search..." />
                        <button class="morphsearch-submit" type="submit">Search</button>
                    </form>
                    <div class="morphsearch-content">
                        <div class="dummy-column">
                            <h2>People</h2>
                            <a class="dummy-media-object" href="#!">
                                <img class="round"
                                    src="http://0.gravatar.com/avatar/81b58502541f9445253f30497e53c280?s=50&d=identicon&r=G"
                                    alt="Sara Soueidan" />
                                <h3>Sara Soueidan</h3>
                            </a>
                            <a class="dummy-media-object" href="#!">
                                <img class="round"
                                    src="http://1.gravatar.com/avatar/9bc7250110c667cd35c0826059b81b75?s=50&d=identicon&r=G"
                                    alt="Shaun Dona" />
                                <h3>Shaun Dona</h3>
                            </a>
                        </div>
                        <div class="dummy-column">
                            <h2>Popular</h2>
                            <a class="dummy-media-object" href="#!">
                                <img src="assets/images/avatar-1.png" alt="PagePreloadingEffect" />
                                <h3>Page Preloading Effect</h3>
                            </a>
                            <a class="dummy-media-object" href="#!">
                                <img src="assets/images/avatar-1.png" alt="DraggableDualViewSlideshow" />
                                <h3>Draggable Dual-View Slideshow</h3>
                            </a>
                        </div>
                        <div class="dummy-column">
                            <h2>Recent</h2>
                            <a class="dummy-media-object" href="#!">
                                <img src="assets/images/avatar-1.png" alt="TooltipStylesInspiration" />
                                <h3>Tooltip Styles Inspiration</h3>
                            </a>
                            <a class="dummy-media-object" href="#!">
                                <img src="assets/images/avatar-1.png" alt="NotificationStyles" />
                                <h3>Notification Styles Inspiration</h3>
                            </a>
                        </div>
                    </div>
                    <!-- /morphsearch-content -->
                    <span class="morphsearch-close"><i class="icofont icofont-search-alt-1"></i></span>
                </div>
                <!-- search end -->
            </div>
        </div>
    </div>
</nav>